import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AliwangwangOutlinedSvg from "@ant-design/icons-svg/es/asn/AliwangwangOutlined";
import AntdIcon from '../components/AntdIcon';
var AliwangwangOutlined = function AliwangwangOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: AliwangwangOutlinedSvg
  }));
};
AliwangwangOutlined.displayName = 'AliwangwangOutlined';
export default /*#__PURE__*/React.forwardRef(AliwangwangOutlined);